export default 'https://tme.understood.org/assets/T_DisplacementNoise001.179b3b32.jpg'